import styled from "@emotion/styled";
import { toastTheme } from "./toastTheme";
export const ToastStyled = styled("div")`
    min-height: 48px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;

    color: ${_ref => {
  let {
    themeMode,
    type
  } = _ref;
  return `var(--sds--toast--color, ${toastTheme.fontColor[type](themeMode)})`;
}};
    background-color: ${_ref2 => {
  let {
    themeMode,
    type
  } = _ref2;
  return `var(--sds--toast--background-color, ${toastTheme.backgroundColor[type](themeMode)})`;
}};

    font-weight: 500;
    font-size: 14px;

    box-shadow: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return toastTheme.boxShadow(themeMode);
}};

    border-radius: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return toastTheme.borderRadius(themeMode);
}};
`;
//# sourceMappingURL=ToastStyled.js.map